import { ProductsTable } from './ProductsTable/ProductsTable';

export const ProductsPage = () => {
  return (
    <div className='w-full p-4 pt-6'>
      <ProductsTable />
    </div>
  );
};
